import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "item", "total"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.itemTargets.forEach(item => {
      item.checked = checked
      item.closest("tr").style.fontWeight = checked ? "bold" : "normal"
    })
    this._recalculate()
  }

  toggleItem(event) {
    event.currentTarget.closest("tr").style.fontWeight = event.currentTarget.checked ? "bold" : "normal"
    this._recalculate()
  }

  _recalculate() {
    let total = 0
    this.itemTargets.forEach(item => {
      if (item.checked) total += parseFloat(item.dataset.valor) || 0
    })
    this.totalTarget.textContent = total.toFixed(2)
  }
}
